import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postExport = async (type, format, listId) => {
  if(!type || !format){
    return false
  }
  const apiURL = API_HOST + '/export/' + type +'.' + format+'?listId='+listId;
  const { token, userID } = useCurrentUser();
  
  try {
    const result = await axios.post(apiURL,{
    },{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return result;
  } catch (error) {
    console.error(error);
  }
};
